module.exports = __webpack_public_path__ + "static/media/identicon-bg.4673119f.svg";